/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CaseManagementUserDto } from './case-management-user-dto';
import { DocumentDto } from './document-dto';

//<custom-head>
import { parseDate, formattedDate } from 'app/utils';
import { toZonedTime } from 'date-fns-tz';
import { environment } from 'environments/environment';
//</custom-head>

export class MessageDto {
  public id: string = undefined;
  public caseId: string = undefined;
  public timestampUtc: Date | string;
  public content: string = undefined;
  public caseManagerSenderId: string = undefined;
  public caseManagerSender: string = undefined;
  public caseManagerCompany: string = undefined;
  public firstLineSenderId: string = undefined;
  public firstLineSender: string = undefined;
  public firstLineCompany: string = undefined;
  public customerSenderId: string = undefined;
  public customerSender: string = undefined;
  public customerCompany: string = undefined;
  public unread: boolean;
  public readByEcus: Date | string;
  public readByCustomer: Date | string;
  public handled: boolean;
  public handler: CaseManagementUserDto;
  public handledUtc: Date | string;
  public internal: boolean;
  public documents: DocumentDto[];

  //<custom-body>
  constructor(source: MessageDto) {
    Object.assign(this, source);

    this.timestampUtc = toZonedTime(source.timestampUtc, environment.timezone);
    this.handledUtc = parseDate(source.handledUtc);
    this.readByCustomer = parseDate(source.readByCustomer);
    this.readByEcus = parseDate(source.readByEcus);

    this.handler = source.handler ? new CaseManagementUserDto(source.handler) : null;

    this.documents = source.documents ? source.documents.map((s: any) => new DocumentDto(s)) : null;
  }

  public get senderId(): string {
    return this.caseManagerSenderId || this.firstLineSenderId || this.customerSenderId;
  }
  public get sender(): string {
    return this.caseManagerSender || this.firstLineSender || this.customerSender;
  }
  public get senderCompany(): string {
    return this.caseManagerCompany || this.firstLineCompany || this.customerCompany;
  }
  public get fromCustomer(): boolean {
    return !(this.caseManagerSenderId || this.firstLineSenderId);
  }

  public get createdDate(): string {
    return formattedDate(parseDate(this.timestampUtc), true);
  }

  public get isHandled(): boolean {
    return !!this.handledUtc;
  }

  public get sentByUser(): boolean {
    return this.fromCustomer;
  }

  public get sentByCaseManager(): boolean {
    return !this.fromCustomer;
  }

  // public get unread(): boolean {
  //   if (this._unread != null)
  //     return this._unread;

  //   if (this.fromCustomer && this.readByEcus != null)
  //     return false;
  //   else if (!this.fromCustomer && this.readByCustomer != null)
  //     return false;

  //   return true;
  // }

  // public set unread(newVal: boolean) {
  //   this._unread = newVal;
  // }

  public get handledBy(): string {
    return this.handler ? this.handler.name : '';
  }
  //</custom-body>
}
